import React, { useState } from "react";
import {
  Paper,
  Box,
  Typography,
  IconButton,
  Divider,
  Collapse,
} from "@mui/material";

import { ReactComponent as PullUp } from "assets/images/icons/icn_pullup.svg";
import { ReactComponent as DropDown } from "assets/images/icons/icn_dropdown.svg";
import { useTheme } from "@mui/material/styles";

const CollapseCard = ({ title, children, showHeader = true, minWidth = 'auto' }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  return (
    <Paper
      elevation={1}
      sx={{
        minWidth,
        width: "100%",
        height: "100%",
        borderRadius: theme.shape.customBorderRadius[4],
        border: `1px solid  ${theme.palette.primary.greyThread}`,
      }}
    >
      {/* Header */}
      {
        showHeader && (
          <>
            <Box
              sx={{
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() => setOpen(!open)}
            >
              <Typography
                sx={{
                  fontSize: theme.typography.customFontSize[3],
                  color: theme.palette.primary.main,
                  fontFamily: theme.typography.fontFamily,
                  fontWeight: theme.typography.customFontWeight[1],
                }}
              >
                {title}
              </Typography>
              <IconButton size="small">{open ? <PullUp /> : <DropDown />}</IconButton>
            </Box>
            {open && <Divider />}
          </>
        )
      }

      {/* Collapse Content */}
      <Collapse in={open} timeout="auto">
        <Box sx={{ m: 2, display: "flex", flexDirection: "column" }}>
          {children}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default CollapseCard;
